import { takeLatest } from 'redux-saga/effects';
import fetchProductsForPurchaseOrderWorker from './addBulkItemsInPurchaseOrderWorkerSaga';
import {
    FETCH_PRODUCT_LIST_REQUEST,
} from '../../redux/modules/addBulkItemsInPurchaseOrder/addBulkItemsInPurchaseOrder-actions';

function* fetchProductList() {
    yield takeLatest(FETCH_PRODUCT_LIST_REQUEST, fetchProductsForPurchaseOrderWorker);
}

export default fetchProductList;
